<script>
export default {
    name: "InvoiceReportPrint",

    data() {

        return {
            invoices: [],
        };
    },

    computed: {

        totalAmount() {
            if(!this.invoices.length) return 0;

            return this.invoices.map(inv => inv.amount ? parseFloat(inv.amount): 0)
                .reduce((amt,sum) => sum+amt);
        },

        totalPaid() {
            if(!this.invoices.length) return 0;

            return this.invoices.map(inv => inv.paid ? parseFloat(inv.paid): 0)
                .reduce((amt,sum) => sum+amt);
        },

        totalBalance() {
            if(!this.invoices.length) return 0;

            return this.invoices.map(inv => inv.balance ? parseFloat(inv.balance): 0)
                .reduce((amt,sum) => sum+amt);
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchInvoices(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchInvoices() {

            let url = `AccountsReports/GetInvoicesReport?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.org ? `&OrganizationId=${this.$route.query.org}` : ``;

            return this.$http.get(url).then(response => {
                this.invoices = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">Invoice Report</h5>
        </div>
        <table class="table table-striped">
                  <thead class="text-sm">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/12">Date</th>
                            <th class="p-tiny w-1/12">Organization</th>
                            <th class="p-tiny w-1/6">Patient</th>
                            <!-- <th class="p-tiny w-1/12">IP No</th>
                            <th class="p-tiny w-1/12">OP No</th> -->
                            <th class="p-tiny w-1/12">Member No</th>
                            <th class="p-tiny w-1/12">Dependant</th>
                            <th class="p-tiny w-1/12">Invoice No</th>
                            <th class="p-tiny w-1/12">Invoice By</th>
                            <th class="p-tiny w-1/12">Amt</th>
                            <th class="p-tiny w-1/12">Paid</th>
                            <th class="p-tiny w-1/12">Balance</th>
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="w-full flex text-xs">
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/6" colspan="2">Total Amt: {{ totalAmount | numberFormat }}</th>
                            <th class="p-tiny w-1/6" colspan="2">Total Paid: {{ totalPaid | numberFormat }}</th>
                            <th class="p-tiny w-1/6" colspan="2">Total Balance: {{ totalBalance | numberFormat }}</th>
                            <th class="p-tiny w-1/12"></th>
                        </tr>
                  </tfoot>
                  <tbody class="text-xs flex flex-col items-center">
                      <tr  class="w-full flex" v-for="(invoice, idx) in invoices" :key="idx">
                          <td class="p-tiny w-1/12">{{ invoice.date | dateFormat }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.organization }}</td>
                          <!-- <td class="p-tiny w-1/6">{{ invoice.patient }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.ipfileno }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.opfileno }}</td> -->
                          <td class="p-tiny w-1/6">
                    <h5 class="text-sm leading-5 font-bold text-gray-900">
                      {{ invoice.patient }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      <span class="mr-2">
                          MRN: {{ invoice.patientID || `-` }} </span>
                          <span>IP: {{ invoice.ipfileno || `-` }}</span>
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      OP: {{ invoice.opfileno || `-`  }}
                    </h5>
                     
                  </td>
                          <td class="p-tiny w-1/12">{{ invoice.memberno }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.principalOfDependant }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.invoice_No }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.postedBy }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.amount | numberFormat }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.paid | numberFormat }}</td>
                          <td class="p-tiny w-1/12">{{ invoice.balance | numberFormat }}</td>
                      </tr>
                  </tbody>
              </table>
    </div>
</template>